export default "__VITE_ASSET__bf5b1ad2__"